export const _state = {
    isLoginFetch: false,
    isGetUsersFetch: false,
    isPostUserFetch: false,
    isPutUserFetch: false,
    isDeleteUserFetch: false,
    isLoginError: false,
    errors: {},
    currentUser: {},
    user: {},
    users: [],
};

export function usersReducer(state = _state, action) {

    switch (action.type) {

        case 'API_LOGIN_CLOSE_FETCH':
            return {
                ...state,
                isLoginFetch: false
            };

        case 'CLEAR_USERS_ERRORS':
            return {
                ...state,
                errors: {},
            };

        case 'API_GET_USERS_CLOSE_FETCH':
            return {
                ...state,
                isGetUsersFetch: false
            };

        case 'API_POST_USER_CLOSE_FETCH':
            return {
                ...state,
                isPostUserFetch: false
            };

        case 'API_PUT_USER_CLOSE_FETCH':
            return {
                ...state,
                isPutUserFetch: false
            };

        case 'API_DELETE_USER_CLOSE_FETCH':
            return {
                ...state,
                isDeleteUserFetch: false
            };

        case 'USERS_INITIALIZE':
            localStorage.removeItem('access-token');
            localStorage.removeItem('client');
            localStorage.removeItem('uid');
            return _state;

        case 'USERS_CLEAR':
            return {
                ...state,
                users: [],
            };

        case 'API_AUTH_SIGN_IN':
            return {
                ...state,
                isLoginFetch: true,
            };

        case 'API_AUTH_SIGN_IN_SUCCESS':
            localStorage.setItem('access-token', action.payload.headers['access-token']);
            localStorage.setItem('client', action.payload.headers.client);
            localStorage.setItem('uid', action.payload.headers.uid);
            return {
                ...state,
                isLoginError: false,
                currentUser: action.payload.data.data
            };

        case 'API_AUTH_SIGN_IN_FAIL':
            localStorage.removeItem('access-token');
            localStorage.removeItem('client');
            localStorage.removeItem('uid');

            return {
                ...state,
                isLoginError: true,
            };

        case 'API_AUTH_VALIDATE_TOKEN_SUCCESS':
            return {
                ...state,
                currentUser: action.payload.data.data
            };

        case 'API_AUTH_VALIDATE_TOKEN_FAIL':
            return _state;

        case 'API_AUTH_CREATE_USER':
            return {
                ...state,
                isPostUserFetch: true,
            };

        case 'API_AUTH_CREATE_USER_SUCCESS':
            return {
                ...state,
                errors: {},
                user: action.payload.data,
            };

        case 'API_AUTH_CREATE_USER_FAIL':
            return {
                ...state,
                errors: action.error.response.data.errors,
            };

        case 'API_AUTH_UPDATE_USER':
            return {
                ...state,
                isPutUserFetch: true,
            };

        case 'API_AUTH_UPDATE_USER_SUCCESS':
            return {
                ...state,
                errors: {},
                user: action.payload.data,
            };

        case 'API_AUTH_UPDATE_USER_FAIL':
            return {
                ...state,
                errors: action.error.response.data.errors,
            };

        case 'API_GET_USERS':
            return {
                ...state,
                isGetUsersFetch: true
            };

        case 'API_GET_USERS_SUCCESS':
            return {
                ...state,
                users: action.payload.data,
            };

        case 'API_GET_USERS_FAIL':
            return {
                ...state,
                errors: action.error.response.data.errors,
            };

        case 'API_DELETE_USER':
            return {
                ...state,
                isDeleteUserFetch: true,
            };

        case 'API_DELETE_USER_SUCCESS':
            return {
                ...state,
                user: {},
            };

        case 'API_DELETE_USER_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'SET_EDIT_USER':
            return {
                ...state,
                user: action.payload.user,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/users.js